import axiosNorequest from '@/plugins/axios/noRequestHeader';
import axios from '@/plugins/axios/index';

const AUTH_BASE_URL = `${process.env.VUE_APP_API_URL}`;

// call login api
export async function getListItem(params): Promise<any> {
    const response = await axios.get(`${AUTH_BASE_URL}/nft-markets` + params.toString());
    return response;
}

export async function getListItemV2(): Promise<any> {
    const response = await axios.get(`${AUTH_BASE_URL}/nft-items`);
    return response;
}

// call api count ntf
export async function getCountNtf(): Promise<any> {
    const response = await axiosNorequest.get(`${AUTH_BASE_URL}/nft-items/count`);
    return response;
}

export async function getExpiredBuy(): Promise<any> {
    return await axiosNorequest.get(`${AUTH_BASE_URL}/nft-items/expired-buy`);
}

// call api my collection
export async function getListMyCollectionNotMint(params): Promise<any> {
    let queryParams =
        '?limit=' +
        params.pagination.limit +
        '&page=' +
        params.pagination.page +
        '&order=' +
        params.sort +
        '&symbol=' +
        params.type +
        '&level=' +
        params.level[0] +
        '-' +
        params.level[1] +
        '&status=' +
        params.status +
        '&search=' + params.search;
    return await axios.get(`${AUTH_BASE_URL}/collections${queryParams}`);
}
export async function getListMyCollection(): Promise<any> {
    return await axios.get(`${AUTH_BASE_URL}/collections`);
}

// call api my collection minted
export async function getListMyCollectionMinted(): Promise<any> {
    const response = await axios.get(`${AUTH_BASE_URL}/collections/minted`);
    return response;
}

// call api detail nft
export async function getDetailNft(id): Promise<any> {
    const response = await axios.get(`${AUTH_BASE_URL}/nft-markets/${id}`);
    return response;
}

// call api update_price
export async function updatePrice(id, params): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/nft-markets/${id}/update`, params);
}

// call api sell
export async function sellNft(nft): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/nft-markets/sell`, nft);
}

export async function getCountryCodeInfo(): Promise<any> {
    const response = await axiosNorequest.get(`${AUTH_BASE_URL}/check-country`);
    return response;
}

// call api my collection
export async function getToWallet(id): Promise<any> {
    return await axios.get(`${AUTH_BASE_URL}/checkout/${id}/to-wallet`);
}

// call api my collection
export async function getDomain(): Promise<any> {
    return await axios.get(`${AUTH_BASE_URL}/checkout/get-domain`);
}

// call api check can buy
export async function checkCanBuy(id): Promise<any> {
    return await axios.get(`${AUTH_BASE_URL}/nft-items/${id}/check`);
}
export async function checkCanBuyV2(id): Promise<any> {
    return await axios.get(`${AUTH_BASE_URL}/nft-items/${id}/check`);
}

// call api checkout
export async function checkout(params): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/nft-markets`, params);
}

export async function checkoutV2(params): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/nft-items/buy`, params);
}
// call api checkoutMetamask
export async function checkoutMetamask(params): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/nft-markets`, params);
}

// call api cancelSell
export async function cancelSell(params): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/nft-markets/` + params + `/cancel`);
}

// call api transaction
export async function getTransaction(type, pagi): Promise<any> {
    var pagiStr = '?per_page=' + pagi.per_page + '&page=' + pagi.page;
    return await axios.get(`${AUTH_BASE_URL}/histories/` + type + pagiStr);
}

export async function getTransactionV2(pagi): Promise<any> {
    let pagiStr = '?per_page=' + pagi.per_page + '&page=' + pagi.page;
    return await axios.get(`${AUTH_BASE_URL}/histories/V2` + pagiStr);
}

// call api metamask
export async function metamask(params): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/metamask`, params);
}

// call api firework
export async function firework(): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/firework`);
}

// call api firework config
export async function fireworkConfig(): Promise<any> {
    return await axios.get(`${AUTH_BASE_URL}/firework/config`);
}

// call api get token sale
export async function getTokenList(): Promise<any> {
    return await axios.get(`${AUTH_BASE_URL}/tokens/list`);
}
export async function getListBuyToken(): Promise<any> {
    return await axios.get(`${AUTH_BASE_URL}/nft-items/list-buy`);
}
// call api sell
export async function transferNft(nft): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/transfer-nft`, nft);
}



// new feature

export async function getListTokenPriceSellNft(): Promise<any> {
    return await axios.get(`${AUTH_BASE_URL}/market/list-token-sell`);
}

export async function getListTokenMarketP2p(params): Promise<any> {
    let queryParams =
        '?limit=' +
        params.pagination.limit +
        '&page=' +
        params.pagination.page +
        '&order= ' +
        params.sort +
        '&symbol=' +
        params.type +
        '&level=' +
        params.level[0] +
        '-' +
        params.level[1] +
        '&sellIn=' +
        params.token +
        '&search=' + params.search ;
    return await axios.get(`${AUTH_BASE_URL}/market${queryParams}`);
}

export async function getListTokenMarketP2pPublic(params): Promise<any> {
    let queryParams =
        '?limit=' +
        params.pagination.limit +
        '&page=' +
        params.pagination.page +
        '&order= ' +
        params.sort +
        '&symbol=' +
        params.type +
        '&level=' +
        params.level[0] +
        '-' +
        params.level[1] +
        '&sellIn=' +
        params.token +
        '&search='+ params.search ;
    return await axios.get(`${AUTH_BASE_URL}/market/list-public${queryParams}`);
}

export async function buyNft(nft): Promise<any> {
    return await axios.post(`/market/buy`, nft);
}

export async function cancelSellNft(id): Promise<any> {
    return await axios.post(`/market/${id}/cancel`);
}

export async function sellNftApi(params): Promise<any> {
    return await axios.post(`/market/sell`, params);
}

export async function updateSellNftApi(params, id): Promise<any> {
    return await axios.post(`/market/${id}/update`, params);
}

export async function getListLeaf(): Promise<any> {
    return await axios.get(`/leaf`);
}

export async function buyLeaf(params): Promise<any> {
    return await axios.post(`/leaf/buy`, params);
}

export async function getListTicket(): Promise<any> {
    return await axios.get(`/ticket`);
}

export async function buyTicket(params): Promise<any> {
    return await axios.post(`/ticket/buy`, params);
}
export async function getListTransaction(params): Promise<any> {
    let queryParams =
        '?limit=' +
        params.pagination.limit +
        '&page=' +
        params.pagination.page +
        '&type= ' +
        params.type +
        '&order=' + params.sortKey + ':' + params.sortValue;
    return await axios.get(`${AUTH_BASE_URL}/transaction${queryParams}`);
}
